export default {
  websiteBaseUrl: 'https://staging.vusocial.com',
  apiBaseUrl: 'https://staging.roomvu.com/api',
  dashboardBaseUrl: 'https://staging.roomvu.com/dashboard',
  imgBaseUrl: 'https://img.roomvu.com/',
  useProxyForApiCall: false,
  gtm: {
    id: 'GTM-TN2N9HVR',
    anonymousId: 'GTM-TN2N9HVR',
  },
  auth: {
    loginUrl: 'https://staging.roomvu.com/login',
    loginApiUrl: '/user/login',
    userAuthenticationUrl: '/user/get',
  },
  googleCaptcha: {
    siteKey: '6LeuuJcUAAAAAJtpfdUpKvjxk62bbz3KCNVfGkuz',
  },
  webEngage: {
    licenseCode: '82617805',
  },
  intrack: {
    IntrackAppKey: 'XXXXXXXXX',
    IntrackAuthKey: 'XXXXXXXXX',
    IntrackPublicKey: 'XXXXXXXXX',
  },
  facebook: {
    appId: '629792100977483',
  },
  intercom: {
    IntercomAppID: 'XXXXXXXXX',
  },
  clarity: {
    projectId: 'XXXXXXXXXX',
  },
  sentry: {
    DSN: 'https://0f2b2605c4334568a8e46d435cc7f6f1@sentry.roomvu.com/5',
    environment: 'staging',
  },
  stripe: {
    key: 'pk_test_SAS3NwDrUpHXlhtCUUVhe50t',
  },
};
